var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yt-tab"},[_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"yt-tab__item",class:{
      active: +_vm.selectedIndex === index,
      divider: _vm.tabs.length > 2 && index,
    },on:{"click":function($event){return _vm.$emit('select', index)}}},[(tab.icon)?_c('svg-inline',{staticClass:"yt-tab__item__icon"},[_c('Icon',{attrs:{"icon":tab.icon,"color":tab.iconColor || '#121212'}})],1):_vm._e(),_c('span',{domProps:{"textContent":_vm._s(tab.label)}})],1)}),_c('div',{staticClass:"yt-tab__selected",style:(_vm.selectedStyle)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }